<script setup lang="ts">
defineProps({
  speed: {
    type: Number,
    default: 1,
    description: 'Animation speed multiplier (1 = normal, 2 = twice as fast, 0.5 = half speed)'
  }
})
</script>

<template>
  <div class="w-full h-full pointer-events-none overflow-hidden absolute inset-0" :class="$attrs.class">
    <svg 
      viewBox="0 0 100 100" 
      preserveAspectRatio="xMidYMid slice"
      class="absolute inset-0 w-full h-full opacity-30"
    >
      <defs>
        <radialGradient id="Gradient1" cx="50%" cy="50%" fx="0.441602%" fy="50%" r=".5">
          <animate attributeName="fx" :dur="`${34/speed}s`" values="0%;3%;0%" repeatCount="indefinite" />
          <stop offset="0%" stop-color="rgba(255, 182, 255, 0.8)" />
          <stop offset="100%" stop-color="rgba(255, 182, 255, 0)" />
        </radialGradient>
        <radialGradient id="Gradient2" cx="50%" cy="50%" fx="2.68147%" fy="50%" r=".5">
          <animate attributeName="fx" :dur="`${23.5/speed}s`" values="0%;3%;0%" repeatCount="indefinite" />
          <stop offset="0%" stop-color="rgba(182, 225, 255, 0.8)" />
          <stop offset="100%" stop-color="rgba(182, 225, 255, 0)" />
        </radialGradient>
        <radialGradient id="Gradient3" cx="50%" cy="50%" fx="0.836536%" fy="50%" r=".5">
          <animate attributeName="fx" :dur="`${21.5/speed}s`" values="0%;3%;0%" repeatCount="indefinite" />
          <stop offset="0%" stop-color="rgba(200, 255, 218, 0.8)" />
          <stop offset="100%" stop-color="rgba(200, 255, 218, 0)" />
        </radialGradient>
      </defs>
      
      <rect 
        x="13.744%" 
        y="1.18473%" 
        width="100%" 
        height="100%" 
        fill="url(#Gradient1)" 
        transform="rotate(334.41 50 50)"
        class="mix-blend-multiply"
      >
        <animate attributeName="x" :dur="`${20/speed}s`" values="25%;0%;25%" repeatCount="indefinite" />
        <animate attributeName="y" :dur="`${21/speed}s`" values="0%;25%;0%" repeatCount="indefinite" />
        <animateTransform 
          attributeName="transform" 
          type="rotate" 
          from="0 50 50" 
          to="360 50 50" 
          :dur="`${7/speed}s`" 
          repeatCount="indefinite"
        />
      </rect>
      
      <rect 
        x="-2.17916%" 
        y="35.4267%" 
        width="100%" 
        height="100%" 
        fill="url(#Gradient2)" 
        transform="rotate(255.072 50 50)"
        class="mix-blend-multiply"
      >
        <animate attributeName="x" :dur="`${23/speed}s`" values="-25%;0%;-25%" repeatCount="indefinite" />
        <animate attributeName="y" :dur="`${24/speed}s`" values="0%;50%;0%" repeatCount="indefinite" />
        <animateTransform 
          attributeName="transform" 
          type="rotate" 
          from="0 50 50" 
          to="360 50 50" 
          :dur="`${12/speed}s`" 
          repeatCount="indefinite"
        />
      </rect>
      
      <rect 
        x="9.00483%" 
        y="14.5733%" 
        width="100%" 
        height="100%" 
        fill="url(#Gradient3)" 
        transform="rotate(139.903 50 50)"
        class="mix-blend-multiply"
      >
        <animate attributeName="x" :dur="`${25/speed}s`" values="0%;25%;0%" repeatCount="indefinite" />
        <animate attributeName="y" :dur="`${12/speed}s`" values="0%;25%;0%" repeatCount="indefinite" />
        <animateTransform 
          attributeName="transform" 
          type="rotate" 
          from="360 50 50" 
          to="0 50 50" 
          :dur="`${9/speed}s`" 
          repeatCount="indefinite"
        />
      </rect>
    </svg>
  </div>
</template>

<style scoped>
/* Add any additional styling here if needed */
</style>
